import { Body, BodyProps } from '@components/text';

export interface ContentTitleProps extends BodyProps {
  children: React.ReactNode;
  lineClamp?: 1 | 2;
}

/**
 * ContentTitle - use as embedded text, also used in ContentMeta
 * @prop lineClamp - specify if 1- or 2-line version
 * @prop children - text to display
 */
export const ContentTitle: React.FC<ContentTitleProps> = ({ lineClamp = 1, children, ...rest }) => (
  <Body
    className="vds-content-title"
    variant="body-02"
    size="medium"
    weight="regular"
    color="primary"
    lineClamp={lineClamp}
    {...rest}>
    {children}
  </Body>
);
